import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, ViewChild, NgModule } from '@angular/core';
import * as i5 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i7 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import * as i3 from 'primeng/button';
import { ButtonModule } from 'primeng/button';
import * as i4 from 'primeng/card';
import { CardModule } from 'primeng/card';
import * as i6 from 'primeng/dialog';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import * as i8 from 'primeng/inputtext';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import * as i2 from '@kdose/ng-auth';
import { InitializationStatus, OtpConfiguration, KDOAuthenticationModule } from '@kdose/ng-auth';
import { Subject, takeUntil } from 'rxjs';
import * as i1 from '@angular/router';
const _c0 = ["form"];
function LoginComponent_p_card_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p-card")(1, "h3", 5);
    i0.ɵɵtext(2, "Anmeldung wird initialisiert");
    i0.ɵɵelementEnd()();
  }
}
function LoginComponent_p_card_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p-card")(1, "h3", 5);
    i0.ɵɵtext(2, "Anmeldung konnte nicht gestartet werden.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵtext(4, " Bitte laden Sie die Seite neu. Sollte der Fehler bestehen bleiben, bitte an den Administrator wenden. ");
    i0.ɵɵelementEnd()();
  }
}
function LoginComponent_p_card_2_form_3_small_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 20);
    i0.ɵɵtext(1, "Dieses Feld muss ausgef\xFCllt werden.");
    i0.ɵɵelementEnd();
  }
}
function LoginComponent_p_card_2_form_3_small_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 21);
    i0.ɵɵtext(1, "Dieses Feld muss ausgef\xFCllt werden.");
    i0.ɵɵelementEnd();
  }
}
function LoginComponent_p_card_2_form_3_div_14_small_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 25);
    i0.ɵɵtext(1, "Dieses Feld muss ausgef\xFCllt werden.");
    i0.ɵɵelementEnd();
  }
}
function LoginComponent_p_card_2_form_3_div_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10)(1, "label", 22);
    i0.ɵɵtext(2, "Token");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 23, 3);
    i0.ɵɵtwoWayListener("ngModelChange", function LoginComponent_p_card_2_form_3_div_14_Template_input_ngModelChange_3_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(3);
      i0.ɵɵtwoWayBindingSet(ctx_r2.otp, $event) || (ctx_r2.otp = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, LoginComponent_p_card_2_form_3_div_14_small_5_Template, 2, 0, "small", 24);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const otpModel_r5 = i0.ɵɵreference(4);
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.otp);
    i0.ɵɵproperty("required", ctx_r2.otpConfiguration === ctx_r2.OtpConfiguration.REQUIRED);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.showErrorMessage(otpModel_r5, "required"));
  }
}
function LoginComponent_p_card_2_form_3_div_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵelement(1, "hr", 27);
    i0.ɵɵelementStart(2, "span", 28);
    i0.ɵɵtext(3, "oder");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "hr", 27);
    i0.ɵɵelementEnd();
  }
}
function LoginComponent_p_card_2_form_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "form", 9, 0);
    i0.ɵɵlistener("submit", function LoginComponent_p_card_2_form_3_Template_form_submit_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.submitLoginForm($event));
    });
    i0.ɵɵelementStart(2, "div", 10)(3, "label", 11);
    i0.ɵɵtext(4, "Benutzername");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "input", 12, 1);
    i0.ɵɵtwoWayListener("ngModelChange", function LoginComponent_p_card_2_form_3_Template_input_ngModelChange_5_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r2.username, $event) || (ctx_r2.username = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, LoginComponent_p_card_2_form_3_small_7_Template, 2, 0, "small", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 10)(9, "label", 14);
    i0.ɵɵtext(10, "Passwort");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "input", 15, 2);
    i0.ɵɵtwoWayListener("ngModelChange", function LoginComponent_p_card_2_form_3_Template_input_ngModelChange_11_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r2.password, $event) || (ctx_r2.password = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(13, LoginComponent_p_card_2_form_3_small_13_Template, 2, 0, "small", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, LoginComponent_p_card_2_form_3_div_14_Template, 6, 3, "div", 17);
    i0.ɵɵelementStart(15, "div", 10)(16, "button", 18);
    i0.ɵɵtext(17, " Anmelden ");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(18, LoginComponent_p_card_2_form_3_div_18_Template, 5, 0, "div", 19);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const usernameModel_r6 = i0.ɵɵreference(6);
    const passwordModel_r7 = i0.ɵɵreference(12);
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.username);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.showErrorMessage(usernameModel_r6, "required"));
    i0.ɵɵadvance(4);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.password);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.showErrorMessage(passwordModel_r7, "required"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.otpConfiguration === ctx_r2.OtpConfiguration.OPTIONAL || ctx_r2.otpConfiguration === ctx_r2.OtpConfiguration.REQUIRED);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r2.oauthProviders == null ? null : ctx_r2.oauthProviders.length);
  }
}
function LoginComponent_p_card_2_div_4_ng_container_1_img_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 33);
  }
  if (rf & 2) {
    const oauth_r8 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵpropertyInterpolate1("alt", "Symbol f\xFCr ", oauth_r8.name, "");
    i0.ɵɵproperty("src", oauth_r8.iconUrl, i0.ɵɵsanitizeUrl);
  }
}
function LoginComponent_p_card_2_div_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 31);
    i0.ɵɵtemplate(2, LoginComponent_p_card_2_div_4_ng_container_1_img_2_Template, 1, 3, "img", 32);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const oauth_r8 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("href", oauth_r8.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", oauth_r8.iconUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", oauth_r8.name, " ");
  }
}
function LoginComponent_p_card_2_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵtemplate(1, LoginComponent_p_card_2_div_4_ng_container_1_Template, 4, 3, "ng-container", 30);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.oauthProviders);
  }
}
function LoginComponent_p_card_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-card")(1, "h3", 5);
    i0.ɵɵtext(2, "Bei Ihrem Konto anmelden");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, LoginComponent_p_card_2_form_3_Template, 19, 6, "form", 6)(4, LoginComponent_p_card_2_div_4_Template, 2, 1, "div", 7);
    i0.ɵɵelementStart(5, "p-dialog", 8);
    i0.ɵɵtwoWayListener("visibleChange", function LoginComponent_p_card_2_Template_p_dialog_visibleChange_5_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r2.showInvalidLoginMessage, $event) || (ctx_r2.showInvalidLoginMessage = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r2.formLogin);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.oauthProviders == null ? null : ctx_r2.oauthProviders.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("header", ctx_r2.invalidLoginMessage);
    i0.ɵɵtwoWayProperty("visible", ctx_r2.showInvalidLoginMessage);
    i0.ɵɵproperty("modal", true)("draggable", false)("resizable", false);
  }
}
class LoginComponent {
  constructor(activatedRoute, authentication, cdr) {
    this.activatedRoute = activatedRoute;
    this.authentication = authentication;
    this.cdr = cdr;
    this.InitializationStatus = InitializationStatus;
    this.OtpConfiguration = OtpConfiguration;
    this.form = null;
    this.formLogin = null;
    this.initializationStatus = InitializationStatus.NONE;
    this.invalidLoginMessage = 'Benutzername oder Passwort unbekannt.';
    this.oauthProviders = [];
    this.otpConfiguration = OtpConfiguration.NONE;
    this.showInvalidLoginMessage = false;
    this.username = '';
    this.password = '';
    this.otp = '';
    this.destroy$ = new Subject();
  }
  ngOnInit() {
    const invalidLoginMessage = Reflect.get(this.activatedRoute.snapshot.data, 'invalidLoginMessage') ?? null;
    if (invalidLoginMessage) {
      this.invalidLoginMessage = invalidLoginMessage;
    }
    this.authentication.authProviders.pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.formLogin = data?.formLogin ?? null;
      this.oauthProviders = data?.oauth ?? [];
      this.otpConfiguration = data?.otp ?? OtpConfiguration.NONE;
      this.cdr.markForCheck();
    });
    this.authentication.initializationStatus.pipe(takeUntil(this.destroy$)).subscribe(status => {
      this.initializationStatus = status;
      this.cdr.markForCheck();
    });
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
  validateForm() {
    return !!this.form && !!this.username && !!this.password && (this.otpConfiguration !== OtpConfiguration.REQUIRED || !!this.otp);
  }
  showErrorMessage(model, key) {
    return !!(model.invalid && (model.dirty || model.touched) && model.errors && Reflect.has(model.errors, key));
  }
  submitLoginForm(event) {
    event.stopPropagation();
    event.preventDefault();
    if (this.form && this.form.nativeElement && this.form.nativeElement.checkValidity() && this.formLogin) {
      this.authentication.login(this.username, this.password, this.otp).then(result => {
        if (!result) {
          this.showInvalidLoginMessage = false;
        }
      }).catch(error => {
        console.log({
          error
        });
      });
    }
    return false;
  }
  static {
    this.ɵfac = function LoginComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LoginComponent)(i0.ɵɵdirectiveInject(i1.ActivatedRoute), i0.ɵɵdirectiveInject(i2.AuthenticationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: LoginComponent,
      selectors: [["kdose-auth-login"]],
      viewQuery: function LoginComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.form = _t.first);
        }
      },
      decls: 3,
      vars: 3,
      consts: [["form", ""], ["usernameModel", "ngModel"], ["passwordModel", "ngModel"], ["otpModel", "ngModel"], [4, "ngIf"], [1, "card-title"], ["novalidate", "", 3, "submit", 4, "ngIf"], ["class", "w-50 d-flex flex-column align-items-stretch", "role", "group", 4, "ngIf"], [3, "visibleChange", "header", "visible", "modal", "draggable", "resizable"], ["novalidate", "", 3, "submit"], [1, "w-50", "d-flex", "flex-column", "me-3", "align-items-stretch"], ["for", "username"], ["pInputText", "", "id", "username", "name", "username", "required", "", 1, "flex-grow-1", 3, "ngModelChange", "ngModel"], ["class", "mb-2", "id", "username-required", 4, "ngIf"], ["for", "password"], ["pInputText", "", "id", "password", "name", "password", "required", "", "type", "password", 1, "flex-grow-1", 3, "ngModelChange", "ngModel"], ["class", "mb-2", "id", "password-required", 4, "ngIf"], ["class", "w-50 d-flex flex-column me-3 align-items-stretch", 4, "ngIf"], ["pButton", "", "type", "submit"], ["class", "w-50 d-flex flex-row align-items-center py-3", 4, "ngIf"], ["id", "username-required", 1, "mb-2"], ["id", "password-required", 1, "mb-2"], ["for", "otp"], ["pInputText", "", "id", "otp", "name", "otp", 1, "flex-grow-1", 3, "ngModelChange", "ngModel", "required"], ["class", "mb-2", "id", "otp-required", 4, "ngIf"], ["id", "otp-required", 1, "mb-2"], [1, "w-50", "d-flex", "flex-row", "align-items-center", "py-3"], [1, "flex-grow-1"], [1, "px-2"], ["role", "group", 1, "w-50", "d-flex", "flex-column", "align-items-stretch"], [4, "ngFor", "ngForOf"], [1, "p-button", "p-component", 3, "href"], ["aria-hidden", "true", 3, "src", "alt", 4, "ngIf"], ["aria-hidden", "true", 3, "src", "alt"]],
      template: function LoginComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, LoginComponent_p_card_0_Template, 3, 0, "p-card", 4)(1, LoginComponent_p_card_1_Template, 5, 0, "p-card", 4)(2, LoginComponent_p_card_2_Template, 6, 7, "p-card", 4);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.initializationStatus === ctx.InitializationStatus.NONE || ctx.initializationStatus === ctx.InitializationStatus.INITIALIZING);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.initializationStatus === ctx.InitializationStatus.FAILED);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.initializationStatus === ctx.InitializationStatus.SUCCESSFUL);
        }
      },
      dependencies: [ButtonModule, i3.ButtonDirective, CardModule, i4.Card, CommonModule, i5.NgForOf, i5.NgIf, DialogModule, i6.Dialog, DividerModule, FormsModule, i7.ɵNgNoValidate, i7.DefaultValueAccessor, i7.NgControlStatus, i7.NgControlStatusGroup, i7.RequiredValidator, i7.NgModel, i7.NgForm, InputTextModule, i8.InputText, PasswordModule, KDOAuthenticationModule],
      styles: ["a.p-button[_ngcontent-%COMP%]{gap:.375rem}a.p-button[_ngcontent-%COMP%] > img[_ngcontent-%COMP%]{vertical-align:-.125em;flex-shrink:0;width:1em;height:1em}.w-50[_ngcontent-%COMP%]{width:50%}.d-flex[_ngcontent-%COMP%]{display:flex}.d-flex.align-items-center[_ngcontent-%COMP%]{align-items:center}.d-flex.align-items-stretch[_ngcontent-%COMP%]{align-items:stretch}.d-flex.flex-column[_ngcontent-%COMP%]{flex-direction:column}.d-flex.flex-row[_ngcontent-%COMP%]{flex-direction:row}.d-flex.gap-2[_ngcontent-%COMP%]{gap:.5rem}.d-flex[_ngcontent-%COMP%]   .flex-grow-1[_ngcontent-%COMP%]{flex-grow:1}.mb-2[_ngcontent-%COMP%]{margin-block-start:.5rem}.me-3[_ngcontent-%COMP%]{margin-block-end:1rem}.px-2[_ngcontent-%COMP%]{padding-left:.5rem;padding-right:.5rem}.py-3[_ngcontent-%COMP%]{padding-top:1rem;padding-bottom:1rem}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoginComponent, [{
    type: Component,
    args: [{
      changeDetection: ChangeDetectionStrategy.OnPush,
      imports: [ButtonModule, CardModule, CommonModule, DialogModule, DividerModule, FormsModule, InputTextModule, PasswordModule, KDOAuthenticationModule],
      selector: 'kdose-auth-login',
      template: "<p-card *ngIf=\"initializationStatus === InitializationStatus.NONE || initializationStatus === InitializationStatus.INITIALIZING\">\n  <h3 class=\"card-title\">Anmeldung wird initialisiert</h3>\n</p-card>\n<p-card *ngIf=\"initializationStatus === InitializationStatus.FAILED\">\n  <h3 class=\"card-title\">Anmeldung konnte nicht gestartet werden.</h3>\n  <div>\n    Bitte laden Sie die Seite neu. Sollte der Fehler bestehen bleiben, bitte an den Administrator wenden.\n  </div>\n</p-card>\n<p-card *ngIf=\"initializationStatus === InitializationStatus.SUCCESSFUL\">\n  <h3 class=\"card-title\">Bei Ihrem Konto anmelden</h3>\n  <form\n    *ngIf=\"formLogin\"\n    #form\n    (submit)=\"submitLoginForm($event)\"\n    novalidate\n  >\n    <div class=\"w-50 d-flex flex-column me-3 align-items-stretch\">\n      <label for=\"username\">Benutzername</label>\n      <input\n        class=\"flex-grow-1\"\n        pInputText\n        id=\"username\"\n        #usernameModel=\"ngModel\"\n        name=\"username\"\n        [(ngModel)]=\"username\"\n        required\n      />\n      <small\n        *ngIf=\"showErrorMessage(usernameModel, 'required')\"\n        class=\"mb-2\"\n        id=\"username-required\"\n      >Dieses Feld muss ausgef\u00FCllt werden.</small>\n    </div>\n\n    <div class=\"w-50 d-flex flex-column me-3 align-items-stretch\">\n      <label for=\"password\">Passwort</label>\n      <input\n        class=\"flex-grow-1\"\n        pInputText\n        id=\"password\"\n        #passwordModel=\"ngModel\"\n        name=\"password\"\n        [(ngModel)]=\"password\"\n        required\n        type=\"password\"\n      />\n      <small\n        *ngIf=\"showErrorMessage(passwordModel, 'required')\"\n        class=\"mb-2\"\n        id=\"password-required\"\n      >Dieses Feld muss ausgef\u00FCllt werden.</small>\n    </div>\n\n    <div *ngIf=\"otpConfiguration === OtpConfiguration.OPTIONAL || otpConfiguration === OtpConfiguration.REQUIRED\"\n      class=\"w-50 d-flex flex-column me-3 align-items-stretch\"\n    >\n      <label for=\"otp\">Token</label>\n      <input\n        class=\"flex-grow-1\"\n        pInputText\n        id=\"otp\"\n        #otpModel=\"ngModel\"\n        name=\"otp\"\n        [(ngModel)]=\"otp\"\n        [required]=\"otpConfiguration === OtpConfiguration.REQUIRED\"\n      />\n      <small\n        *ngIf=\"showErrorMessage(otpModel, 'required')\"\n        class=\"mb-2\"\n        id=\"otp-required\"\n      >Dieses Feld muss ausgef\u00FCllt werden.</small>\n    </div>\n\n    <div class=\"w-50 d-flex flex-column me-3 align-items-stretch\">\n      <button\n        pButton\n        type=\"submit\"\n      >\n        Anmelden\n      </button>\n    </div>\n    <div *ngIf=\"oauthProviders?.length\"\n      class=\"w-50 d-flex flex-row align-items-center py-3\">\n      <hr class=\"flex-grow-1\">\n      <span class=\"px-2\">oder</span>\n      <hr class=\"flex-grow-1\">\n    </div>\n  </form>\n  <div *ngIf=\"oauthProviders?.length\"\n    class=\"w-50 d-flex flex-column align-items-stretch\" role=\"group\">\n    <ng-container *ngFor=\"let oauth of oauthProviders\">\n      <a class=\"p-button p-component\" href=\"{{oauth.url}}\" >\n        <img *ngIf=\"oauth.iconUrl\" [src]=\"oauth.iconUrl\" alt=\"Symbol f\u00FCr {{oauth.name}}\" aria-hidden=\"true\">\n        {{oauth.name}}\n      </a>\n    </ng-container>\n  </div>\n  <p-dialog [header]=\"invalidLoginMessage\"\n    [(visible)]=\"showInvalidLoginMessage\"\n    [modal]=\"true\"\n    [draggable]=\"false\"\n    [resizable]=\"false\"\n  >\n  </p-dialog>\n\n</p-card>\n",
      styles: ["a.p-button{gap:.375rem}a.p-button>img{vertical-align:-.125em;flex-shrink:0;width:1em;height:1em}.w-50{width:50%}.d-flex{display:flex}.d-flex.align-items-center{align-items:center}.d-flex.align-items-stretch{align-items:stretch}.d-flex.flex-column{flex-direction:column}.d-flex.flex-row{flex-direction:row}.d-flex.gap-2{gap:.5rem}.d-flex .flex-grow-1{flex-grow:1}.mb-2{margin-block-start:.5rem}.me-3{margin-block-end:1rem}.px-2{padding-left:.5rem;padding-right:.5rem}.py-3{padding-top:1rem;padding-bottom:1rem}\n"]
    }]
  }], () => [{
    type: i1.ActivatedRoute
  }, {
    type: i2.AuthenticationService
  }, {
    type: i0.ChangeDetectorRef
  }], {
    form: [{
      type: ViewChild,
      args: ['form']
    }]
  });
})();
class KDOAuthenticationPrimeNgModule {
  static {
    this.ɵfac = function KDOAuthenticationPrimeNgModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || KDOAuthenticationPrimeNgModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: KDOAuthenticationPrimeNgModule,
      imports: [ButtonModule, CardModule, CommonModule, DialogModule, DividerModule, FormsModule, InputTextModule, PasswordModule, KDOAuthenticationModule, LoginComponent],
      exports: [KDOAuthenticationModule, LoginComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [ButtonModule, CardModule, CommonModule, DialogModule, DividerModule, FormsModule, InputTextModule, PasswordModule, KDOAuthenticationModule, LoginComponent, KDOAuthenticationModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(KDOAuthenticationPrimeNgModule, [{
    type: NgModule,
    args: [{
      imports: [ButtonModule, CardModule, CommonModule, DialogModule, DividerModule, FormsModule, InputTextModule, PasswordModule, KDOAuthenticationModule, LoginComponent],
      exports: [KDOAuthenticationModule, LoginComponent]
    }]
  }], null, null);
})();

/*
 * Public API Surface of auth-primeng
 */

/**
 * Generated bundle index. Do not edit.
 */

export { KDOAuthenticationPrimeNgModule, LoginComponent };
